var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scrollbar" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.vertical,
            expression: "vertical"
          }
        ],
        staticClass: "simplebar-track vertical"
      },
      [_c("div", { staticClass: "simplebar-scrollbar" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.horizontal,
            expression: "horizontal"
          }
        ],
        staticClass: "simplebar-track horizontal"
      },
      [_c("div", { staticClass: "simplebar-scrollbar" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "simplebar-scroll-content" }, [
      _c("div", { staticClass: "simplebar-content" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }